import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const GA_ID = process.env.REACT_APP_GA_ID;
const KEY = "ag-consent";

function loadGa() {
  if (!GA_ID || window.gtag) return;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { anonymize_ip: true });
}

export function ConsentBanner() {
  const [choice, setChoice] = useState(() => (typeof window !== "undefined" ? localStorage.getItem(KEY) : "x"));
  useEffect(() => { if (choice === "yes") loadGa(); }, [choice]);
  if (!GA_ID || choice) return null;
  const decide = (v) => { localStorage.setItem(KEY, v); setChoice(v); };
  return (
    <div className="fixed inset-x-3 bottom-24 z-50 rounded-2xl bg-white p-5 shadow-2xl ring-1 ring-slate-200 md:bottom-6 md:left-6 md:right-auto md:max-w-sm" data-testid="consent-banner">
      <p className="text-sm text-slate-700">Nous utilisons un outil de mesure d'audience pour améliorer le site. <Link to="/politique-confidentialite#cookies" className="underline">En savoir plus</Link></p>
      <div className="mt-4 flex gap-2">
        <button onClick={() => decide("yes")} className="btn btn-blue" data-testid="consent-accept">Accepter</button>
        <button onClick={() => decide("no")} className="btn btn-outline" data-testid="consent-refuse">Refuser</button>
      </div>
    </div>
  );
}
